import moment from "moment";
import React from "react";
import {
  Alert,
  Card, Col, Container, Form, FormGroup, Row
} from "react-bootstrap";
import cssModules from "react-css-modules";
import { FormattedMessage, injectIntl } from "react-intl";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { default as SAlert } from "react-s-alert";
import Spinner from "react-spinkit";
import {
  addPresentationAsSpeaker,
  changePresentationPrivacyAsSpeaker, getSpeakerPresentations
} from "../../redux/actions";
import ManagePresentation from "../ManagePresentation";
import style from "./style.scss";


const UploadPresentation = ({ match: { params } }) => {
  return <Redirect to={`/speaker-data/${params.event_id}/${params.speaker_id}?manage=presentation-upload`} />
}

export class UploadPresentationasd extends React.Component {
  constructor(props) {
    super(props);
    this.managePresentation = this.managePresentation.bind(this);
    this.addPresentationAsSpeaker = this.addPresentationAsSpeaker.bind(this);
    this.changePresentationPrivacy = this.changePresentationPrivacy.bind(this);
    this.changePresentationPdfConvert = this.changePresentationPdfConvert.bind(this);

    this.state = {
      presentation: false,
      dateOver: false,
      loading: true,
    };
  }

  componentDidMount() {
    const p = this.props.match.params;
    this.props
      .dispatch(getSpeakerPresentations(p.event_id, p.speaker_id))
      .then(() => {
        this.setState({
          loading: false,
        });
      })
      .catch((err) => {
        this.setState({
          loading: false,
        });
        if (err.message === "error.date-over") {
          this.setState({
            dateOver: true,
          });
        }
      });
  }

  managePresentation(id) {
    this.setState({ presentation: id });
  }

  addPresentationAsSpeaker(_id, file) {
    this.props
      .dispatch(
        addPresentationAsSpeaker(
          {
            _id,
            event_id: this.props.match.params.event_id,
            speaker_id: this.props.match.params.speaker_id,
          },
          file
        )
      )
      .catch((err) => {
        SAlert.error(this.props.intl.formatMessage({ id: err.message }))
      });
  }

  changePresentationPrivacy(e) {
    this.props
      .dispatch(
        changePresentationPrivacyAsSpeaker(
          {
            _id: e.target.attributes.getNamedItem("data-presentation").value,
            event_id: this.props.match.params.event_id,
            speaker_id: this.props.match.params.speaker_id,
          },
          {
            public:
              e.target.attributes.getNamedItem("data-public").value !== "true",
          }
        )
      )
      .then(() =>
        SAlert.success(
          this.props.intl.formatMessage({ id: "presentation.update-success" })
        )
      )
      .catch(() =>
        SAlert.error(
          this.props.intl.formatMessage({ id: "error.server-error" })
        )
      );
  }

  changePresentationPdfConvert(e) {
    this.props
      .dispatch(
        changePresentationPrivacyAsSpeaker(
          {
            _id: e.target.attributes.getNamedItem("data-presentation").value,
            event_id: this.props.match.params.event_id,
            speaker_id: this.props.match.params.speaker_id,
          },
          {
            pdfConvert:
              e.target.attributes.getNamedItem("data-pdf-convert").value !==
              "true",
          }
        )
      )
      .then(() =>
        SAlert.success(
          this.props.intl.formatMessage({ id: "presentation.update-success" })
        )
      )
      .catch(() =>
        SAlert.error(
          this.props.intl.formatMessage({ id: "error.server-error" })
        )
      );
  }

  render() {
    const self = this;

    if (this.state.loading) {
      return (
        <div className="section-padding-page">
          <Container>
            <Spinner spinnerName="wave" />
          </Container>
        </div>
      );
    }

    if (this.state.dateOver) {
      return (
        <div className="section-padding-page">
          <Container>
            <Alert variant="danger">
              <FormattedMessage id="error.last-date-over" />
            </Alert>
          </Container>
        </div>
      );
    }


    return (
      <div className="section-padding-page">
        <Container>
          <Row>
            <Col xs={12}>
              <h1 className="post-header">{this.props.event.name}</h1>
              <div className="event-details margin-bot-20">
                {this.props.event.venue ? (
                  <span>
                    <span>
                      <i className="fa fa-map-signs" /> {this.props.event.venue}
                    </span>
                    <span>
                      <i className="fa fa-calendar" />{" "}
                      {moment(this.props.event.start).isSame(
                        this.props.event.end,
                        "day"
                      )
                        ? moment(this.props.event.start).format("DD/MM/YYYY")
                        : `${moment(this.props.event.start).format(
                          "DD/MM/YYYY"
                        )} to ${moment(this.props.event.end).format(
                          "DD/MM/YYYY"
                        )}`}
                    </span>
                  </span>
                ) : (
                  ""
                )}
              </div>
            </Col>
            {this.props.event.name && this.props.presentations.length === 0 ? (
              <Col xs={12}>
                <Alert variant="danger">
                  <FormattedMessage id="label.no-presentations-for-upload" />
                </Alert>
              </Col>
            ) : (
              <Col xs={12}>
                <h2>
                  <FormattedMessage id="heading.upload-ppt" />
                </h2>



                {this.props.presentations.map((p) => {
                  return (
                    <div>
                      <Card key={p._id}>
                        <Card.Header>{`${p.name}, ${moment(p.date).format(
                          "DD/MM/YYYY"
                        )} ${p.time}`}</Card.Header>
                        <Card.Body>
                          <FormGroup>
                            <Form.Check
                              data-presentation={p._id}
                              data-public={p.public}
                              checked={p.public}
                              onChange={this.changePresentationPrivacy}
                              label={this.props.intl.formatMessage({
                                id: "label.agree-broadcast",
                              })}
                            />
                          </FormGroup>
                          <FormGroup>
                            <Form.Check
                              data-presentation={p._id}
                              data-pdf-convert={p.pdfConvert}
                              checked={p.pdfConvert}
                              onChange={this.changePresentationPdfConvert}
                              label={this.props.intl.formatMessage({
                                id: "label.agree-pdfConvert",
                              })}
                            />
                          </FormGroup>
                          <ManagePresentation
                            signingUrl="/s3/speaker"
                            signingUrlQueryParams={{
                              event_id: self.props.match.params.event_id,
                              speaker_id: self.props.match.params.speaker_id,
                              presentation_id: p._id,
                            }}
                            addFile={this.addPresentationAsSpeaker}
                            presentations={p.ppt}
                            presentation_name={p.name}
                            presentation_id={p._id}
                          />
                        </Card.Body>
                      </Card>
                      <br />
                    </div>
                  );
                })}

              </Col>
            )}
          </Row>
        </Container>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  event: state.event.event,
  presentations: state.event.presentations,
});

export default connect(mapStateToProps)(
  cssModules(injectIntl(UploadPresentation), style)
);
